import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=c480fa14&scoped=true"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"
import style0 from "./Restaurants.vue?vue&type=style&index=0&id=c480fa14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c480fa14",
  null
  
)

export default component.exports